import React, { useState } from "react";
import { makeStyles } from "@mui/styles";

import { UsersManagementProps } from "../../../../pages/v2/UsersPage";

import { Box, Grid, Typography } from "@mui/material";
import { ReactComponent as IconClass } from "../../../../assets/MACS-UserMangmt-Icon-PreAlgebra.svg";
import { EditCourse } from "../EditDetails/EditCourse";
import { ViewCourse } from "../ViewDetails/ViewCourse";
import { SettingsButton } from "../utils/SettingsButton";
import { Courses } from "@backend-types";

const useStyles = makeStyles((theme) => ({
  root: {
    textAlign: "left",
    display: "flex",
    flexDirection: "column",
  },
  gridRow: {
    padding: "0rem 28px 0rem 0px",
    minHeight: "86px",
    borderTop: "#E8E8E8 1px solid",
    "&:hover": {
      backgroundColor: "#F5F5F5",
    },
    cursor: "pointer",
  },
  rowIcon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  gridItem: {
    display: "flex",
    alignItems: "center",
    flexShrink: 0, // Prevents the grid item from shrinking
  },
  stackedData: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1, // Allows this box to grow to fill available space
    flexBasis: "auto", // Basis is automatic, adjusts based on content
    overflow: "hidden", // Hides overflowed text
    marginLeft: "28px",
  },
  fieldData: {
    fontWeight: 500,
    fontSize: 18,
    color: theme.palette.text.secondary,
    whiteSpace: "normal", // Allows text to wrap
    overflow: "hidden",
    textOverflow: "ellipsis", // Adds ellipsis for overflowed text
    maxWidth: "100%", // Ensures the text does not exceed its container
  },
}));

interface CoursesTableProps extends UsersManagementProps {
  courses: Courses[];
}

export const CoursesTable: React.FunctionComponent<CoursesTableProps> = (props) => {
  const classes = useStyles();

  const [viewOpen, setViewOpen] = useState(false);
  const [viewCourse, setViewCourse] = useState<Courses | undefined>();
  const [editOpen, setEditOpen] = useState(false);
  const [editCourse, setEditCourse] = useState<Courses | undefined>();

  const handleEditClose = () => {
    setEditOpen(false);
  };

  const handleViewClose = () => {
    setViewOpen(false);
  };

  const handleEditClick = (course: Courses | undefined) => {
    setEditCourse(course);
    setViewOpen(false);
    setEditOpen(true);
  };

  const handleViewClick = (course: Courses | undefined) => {
    setViewCourse(course);
    setViewOpen(true);
  };

  return (
    <div className={classes.root}>
      <Box sx={{ width: "100%" }}>
        {props.courses?.map((course: Courses) => {
          const actions = [
            {
              label: "Edit",
              color: "#747474",
              onClick: () => handleEditClick(course),
              visible: true,
              isDisabled: false,
            },
            {
              label: "View",
              color: "#747474",
              onClick: () => handleViewClick(course),
              visible: true,
              isDisabled: false,
            },
          ];

          return (
            <Grid
              container
              sx={{ width: "100%" }}
              key={course.id}
              className={classes.gridRow}>
              <Grid
                onClick={() => {
                  handleViewClick(course);
                }}
                item
                xs={10}
                className={classes.gridItem}>
                <Box className={classes.rowIcon}>
                  <IconClass style={{ width: 48, height: 48 }} />
                </Box>
                <Box
                  className={classes.stackedData}
                  sx={{
                    marginLeft: "28px",
                  }}>
                  <Typography className={classes.fieldData}>{course.name}</Typography>
                </Box>
              </Grid>

              <Grid item xs={2} className={classes.gridItem}>
                <Box sx={{ marginLeft: "auto" }}>
                  <SettingsButton
                    label={"Actions"}
                    sectionName={`${course.name}`}
                    actions={actions}
                  />
                </Box>
              </Grid>
            </Grid>
          );
        })}
      </Box>
      <ViewCourse
        open={viewOpen}
        onClose={handleViewClose}
        onEdit={() => handleEditClick(viewCourse)}
        course={viewCourse}
      />
      {editCourse && (
        <EditCourse
          open={editOpen}
          onClose={handleEditClose}
          onSubmit={props.onDelete}
          currentUser={props.currentUser}
          course={editCourse}
        />
      )}
    </div>
  );
};
